/** Iter 639 adj. — staff till split · page-level till state: signed-in
 * staff (sessionStorage), logout, earnings permission + active tab.
 * Returns ONE bag (`const t = useStaffTill()`); cards take `{ t }`. */
import { useState } from "react";

export function useStaffTill() {
  const [staff, setStaff] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem("till_staff") || "null");
    } catch {
      return null;
    }
  });

  const logout = () => {
    sessionStorage.removeItem("till_token");
    sessionStorage.removeItem("till_staff");
    setStaff(null);
  };

  const canEarnings = !!staff?.permissions?.view_earnings_ledger;

  // "sessions" | "earnings" — tabs only render when canEarnings.
  const [tab, setTab] = useState("sessions");

  return { staff, setStaff, logout, canEarnings, tab, setTab };
}
